var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.experience && _vm.experience.experience_photos.length > 0
      ? _c(
          "div",
          [
            _vm.$mq.phone
              ? _c("photos-mobile", { attrs: { experience: _vm.experience } })
              : _c("photos-desktop", {
                  attrs: { numPhotos: 5, experience: _vm.experience }
                }),
            _vm._v(" "),
            _c("Tinybox", {
              attrs: { images: _vm.photoUrls, loop: "", "no-thumbs": "" },
              model: {
                value: _vm.galleryIndex,
                callback: function($$v) {
                  _vm.galleryIndex = $$v
                },
                expression: "galleryIndex"
              }
            })
          ],
          1
        )
      : _c("div", [_c("loader")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b004822", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b004822","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/experience/components/ExperiencePhotos.vue
// module id = 2110
// module chunks = 0